import React from 'react';
import Slider1 from '../../../assets/images/physical_theropy/recoveryOne.jpg';
import Slider2 from '../../../assets/images/physical_theropy/recoveryTwo.jpg';
import Slider3 from '../../../assets/images/physical_theropy/recoveryThree.jpg';
import Slider4 from '../../../assets/images/physical_theropy/recoveryFour.jpg';
import Slider5 from '../../../assets/images/physical_theropy/recoveryFive.jpg';
import Slider6 from '../../../assets/images/physical_theropy/recoverysix.jpg';
import CrossFadeImageSlider from '../../../components/molecules/CrossFadeImageSlider';

const images = [
  {
    src: Slider1,
    alt: 'Stages of concussion recovery protocol infographic in Wasilla pediatric therapy',
  },
  {
    src: Slider2,
    alt: 'Pediatric therapy infographic on post-concussion treatment in Wasilla',
  },
  {
    src: Slider3,
    alt: 'Wasilla pediatric therapy services promotional banner on concussion care',
  },
  {
    src: Slider4,
    alt: 'Pediatric therapy blog post feature image in Wasilla with contact info',
  },
  {
    src: Slider5,
    alt: 'Concussion symptom infographic for pediatric therapy in Wasilla',
  },
  {
    src: Slider6,
    alt: 'What is a concussion infographic in Wasilla pediatric therapy center',
  },
];
function CareAndRecovery() {
  return (
    <div className="bg-[#E8E8E8]">
      <div className="w-full flex flex-col gap-4 sm:gap-6 md:gap-10 max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-10">
        <div
          id="CareAndRecovery"
          style={{
            background:
              'linear-gradient(-45deg, #493F99 0%, #755EA8 67%, #D36CAA 100%)',
          }}
          className="w-full rounded-2xl md:rounded-[50px] p-6 md:px-14 md:pt-10 md:pb-16 mt-4 md:mt-10"
        >
          <h2 className="text-[45px] sm:text-[60px] 3xl:text-[75px] text-white font-bold leading-tight mb-4 border-b-2 pb-2 border-white">
            Concussion Care and Recovery
          </h2>
          <div className="flex flex-col lg:flex-row lg:justify-between gap-4 lg:gap-8 w-full">
            <div className="flex flex-col gap-4 flex-[45%] justify-center">
              <p className="text-white text-xl 2xl:text-xl">
                A concussion, a mild traumatic brain injury from a head blow,
                can cause symptoms like headaches, dizziness, and sensitivity to
                light, lasting up to 14 days. Immediate medical attention is
                needed for severe signs like loss of consciousness or fluid
                drainage from the ear or nose. At Guidepost Pediatrics, we use
                an interdisciplinary approach with physical therapy, including
                aerobic training, vestibular rehabilitation, and patient
                education. Recovery involves a structured return-to-sport
                protocol, starting with 24-48 hours of rest, progressing through
                light activity, sport-specific drills, and full-contact
                practice, with medical clearance at each stage.
              </p>
              <p className="text-white text-xl 2xl:text-xl mt-6">
                Contact us at (907) 376-4880 for personalized care.
              </p>
            </div>
            <div className="flex-[55%] justify-center lg:justify-end items-end flex">
              <CrossFadeImageSlider
                rounded="rounded-3xl"
                width="w-full md:w-[450px] "
                height="h-[300px] sm:h-[400px] md:h-[450px]"
                images={images}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CareAndRecovery;
